<template>
    <div class="lms__user_account_security_mfa">
        <div class="lms__user_account_security_mfa_details">
            <component-title :size="'tiny'">{{ $t('auth.twoFactorAuth.title') }}</component-title>
            <template v-if="userHasMfaEnabled">
                <component-text :html="true" :is-slot="true"><p>{{ $t('auth.twoFactorAuth.text.twoFactorAuthIsCurrently') }} <strong>{{ $t('auth.twoFactorAuth.text.enabled') }}</strong>.</p></component-text>
                <component-text>{{ $t('auth.twoFactorAuth.text.youAreGenerating') }} </component-text>
            </template>
            <template v-else>
                <component-text :html="true" :is-slot="true"><p>{{ $t('auth.twoFactorAuth.text.twoFactorAuthIsCurrently') }} <strong>{{ $t('auth.twoFactorAuth.text.disabled') }}</strong>.</p></component-text>
                <component-text>{{ $t('auth.twoFactorAuth.text.ifYouEnableTwoFactorAuth') }}</component-text>
            </template>
        </div>
        <div class="lms__user_account_security_mfa_configurator">
            <template v-if="userHasMfaEnabled">
                <component-title :size="'tiny'">{{ $t('auth.twoFactorAuth.labels.changeConfiguration') }}</component-title>
            </template>
            <template v-else>
                <component-title :size="'tiny'">{{ $t('auth.twoFactorAuth.labels.authenticationApp') }}</component-title>
            </template>
            <template v-if="userHasMfaRequired && !userHasMfaEnabled">
                <div class="lms__user_account_security_mfa_configurator_error">
                    <component-note
                        :danger="true"
                    >{{ $t('auth.twoFactorAuth.text.setUpTwoFactorAuth') }}
                    </component-note>
                </div>
            </template>
            <lms-user-account-security-mfa-form/>
        </div>
    </div>
</template>

<script>

import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentNote from '@/components/default/shared/ComponentNote'
import LmsUserAccountSecurityMfaForm from '@/components/lms/user/account/LmsUserAccountSecurityMfaForm'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  name: 'lms-user-account-security-mfa',
  components: { ComponentText, LmsUserAccountSecurityMfaForm, ComponentNote, ComponentTitle },
  computed: {
    userHasMfaRequired () {
      return this.$store.getters.getAuthUserHasMfaRequired
    },
    userHasMfaEnabled () {
      return this.$store.getters.getAuthUserHasMfaEnabled
    }
  },
  methods: {
    performSubmitValidate () {
      this.$validator.resume()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch(`lmsUserAccountSecurityUpdate`).then(() => {
            this.$eventBus.$emit('stop-sending')
          })
        } else {
          this.$refs.popnotifyvalidation.openNotify()
        }
      })
    }
  },
  mounted () {
    this.$validator.pause()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/account/_lmsuseraccountsecuritymfa.scss";
</style>
